module.exports = __webpack_public_path__ + "static/media/right-arrow.56c3c3c7.svg";